/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoDayPicker {
    restrict = "E";
    scope = {
      name: "@",
      ngModel: "=ngModel",
      disabled: "=ngDisabled",
      month: "=month",
      required: "=ngRequired",
      tabIndex: "=?"
    };
    
    require = "ngModel";

    templateUrl = "app/components/controls/dayPickerTemplate.html";

    link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
        scope.resolvedDayText = this.$translate.instant("LABEL_DAY");
        scope.getDayNumbers = function (month: number = 1): number[] {
            //use leap year for ng-repeat 
            var noOfDays = new Date(new Date('1/1/2000').getFullYear(), month, 0).getDate();
            var numbers = new Array<number>(noOfDays);
            for (var i = 0; i < noOfDays; i++) {
                numbers[i] = i + 1;
            }
            return numbers;
        }

    }

    constructor(private $translate: angular.translate.ITranslateService) {

    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($translate) => {
        return new MeevoDayPicker($translate);
      };

      directive.$inject = ["$translate"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoDayPicker", MeevoDayPicker.factory());

}